import { Component, Input, ComponentRef, ViewContainerRef, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { BlockModel } from '../../models/block.model';
import { BlockComponent } from '../Block/block.component';
import { ReportBlockTypeEnum } from '../../../Reports/enums/report-block-type.enum';


@Component({
    selector: 'agpr-block-wrapper',
    templateUrl: './block-wrapper.component.html',
    styleUrls: ['./block-wrapper.component.scss'],
    standalone: false
})
export class BlockWrapperComponent implements OnDestroy  {
    blockComponent: BlockComponent;
    _blockPosition: string;
    _inlineAdderAdjustment: boolean = false;;
    _actionMenuTextAlignment: string;

    componentChangeSubscription: Subscription;

    @Input() set actionMenuTextAlignment(value: string) {
        this._actionMenuTextAlignment = value;
        if (this.blockComponent) {
            this.blockComponent.actionMenuTextAlignment = this._actionMenuTextAlignment;
        }
    }

    @Input() set blockPosition(position: string){
        this._blockPosition = position;
        if (!!this.blockComponent){
            this.blockComponent.blockPosition = this._blockPosition;
        }
    };

    @Input() set block(blk: BlockModel) {
        this.setBlock(blk);

        if (this.componentChangeSubscription) {
            this.componentChangeSubscription.unsubscribe();
            this.componentChangeSubscription = null;
        }

        if (blk &&
            (
                blk.type.key === ReportBlockTypeEnum.TOP_TERMS ||
                blk.type.key === ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME ||
                blk.type.key === ReportBlockTypeEnum.TOP_10_OUTLETS
            )
        ) {
            this.componentChangeSubscription = blk.componentChange$.subscribe(change => {
                if (change){
                    this.setBlock(blk);
                }
            });
        }
    }
    _preview: boolean = false;
    @Input() set preview(state: boolean) {
        this._preview = state;
        if (this.blockComponent) {
            this.blockComponent.preview = state;
        }
    }

    _actionable: boolean = true;
    @Input() set actionable(actionable: boolean) {
        this._actionable = actionable;
        if (this.blockComponent) {
            this.blockComponent.actionable = actionable;
        }
    }

    _isInLayoutBlock: boolean = false;
    @Input() set isInLayoutBlock(isIn: boolean) {
        this._isInLayoutBlock = isIn;
        if (this.blockComponent) {
            this.blockComponent.isInLayoutBlock = isIn;
        }
    }
    get isInLayoutBlock() {
        return this._isInLayoutBlock;
    }

    _isInCuratorBlock: boolean = false;
    @Input() set isInCuratorBlock(isIn: boolean) {
        this._isInCuratorBlock = isIn;
        if (this.blockComponent) {
            this.blockComponent.isInCuratorBlock = isIn;
        }
    }
    get isInCuratorBlock() {
        return this._isInCuratorBlock;
    }

    _isRightMost: boolean = false;
    @Input() set isRightMost(isRightMost: boolean) {
        this._isRightMost = isRightMost;
        if (this.blockComponent) {
            this.blockComponent.isRightMost = isRightMost;
        }
    }
    get isRightMost() {
        return this._isRightMost;
    }

    @Input() hideTooltip: boolean = false;

    @Input() set inlineAdderAdjustment(value: boolean) {
        this._inlineAdderAdjustment = value;
        if (this.blockComponent) {
            this.blockComponent.inlineAdderAdjustment = this._inlineAdderAdjustment;
        }
    }

    @Output() keydown: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();

    constructor(
        protected viewContainer: ViewContainerRef
    ) {}

    /**
     * Creates the block component for a given block so that it can be rendered on the page.
     *
     * @param block The block to add
     */
    protected setBlock(block: BlockModel): ComponentRef<BlockComponent> {
        this.viewContainer.clear();

        const blockComponentType = block.type.componentType || BlockComponent;
        const componentRef = this.viewContainer.createComponent(blockComponentType);

        componentRef.instance.outputEvent.subscribe((event: KeyboardEvent) => this.keydown.emit(event));

        this.blockComponent = componentRef.instance;
        this.blockComponent.preview = this._preview;
        this.blockComponent.actionable = this._actionable;
        this.blockComponent.block = block;
        this.blockComponent.blockPosition = this._blockPosition;
        this.blockComponent.isInLayoutBlock = this.isInLayoutBlock;
        this.blockComponent.isInCuratorBlock = this.isInCuratorBlock;
        this.blockComponent.isRightMost = this.isRightMost;
        this.blockComponent.hideTooltip = this.hideTooltip;
        this.blockComponent.inlineAdderAdjustment = this._inlineAdderAdjustment;
        this.blockComponent.actionMenuTextAlignment = this._actionMenuTextAlignment;
        return componentRef;
    }

    ngOnDestroy() {
        if (this.componentChangeSubscription) {
            this.componentChangeSubscription.unsubscribe();
        }
    }
}
